import {
  IDeliveryAddress,
  IModel,
  ISingleOrder,
  ISingleOrderedArticleLine,
  ITrackingInfo,
  OrderStatus,
  TransmissionStatus,
} from '@alberta/konexi-shared';

export class SingleOrderDto implements ISingleOrder, IModel {
  trackingInfo: ITrackingInfo[];
  erpOrderNumber: string;
  externalReference: string;
  groupOrderId: string;
  orderNumber: string;
  isGroupOrder: boolean;
  isHospitalPrescriber: boolean;
  regionId: string;
  salesId: string;
  patientId: string;
  integratedCareId: string;
  creationDate: Date;
  deliveryDate: Date;
  reminderDate: Date;
  accountingMonth: number[];
  startDate: Date;
  endDate: Date;
  deliveryAddress: IDeliveryAddress;
  deliveryInformation: string;
  doctorId: string;
  pharmacyId: string;
  therapyId: number;
  therapyTypeId: number;
  location: number;
  expressDelivery: boolean;
  isInitialCare: boolean;
  orderedArticleLines: ISingleOrderedArticleLine[];
  status: OrderStatus;
  annotation: string;
  resmedTenant: string;
  deliveryNote: string;
  deliveryStartTime: string;
  _id: string;
  timestamp: Date;
  archived: boolean;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  hospitalId: string;
  prescriptionStatus: TransmissionStatus;
  tags: string[];
  attachments: string[];
  transmittedAt: string;
  hasFollowUpOrder: boolean;
  auditIds: string[];
  deliveryOption: string;
}
